/** Persistence for the user's own reactions, keyed by video id. */
import { getJSON, setJSON } from './storage.js';

const USER_REACTIONS_KEY = 'userVideoReactions';

/** @returns {Record<string, Record<string, boolean>>} */
export function loadUserReactions() {
  return getJSON(USER_REACTIONS_KEY, {});
}

export function saveUserReactions(map) {
  setJSON(USER_REACTIONS_KEY, map);
}
